// extracted by mini-css-extract-plugin
export default {"overlayWrapper":"Home_overlayWrapper__-dMwG","viewBox":"Home_viewBox__xQx8i"};